export default {
    data () {
        return {
            currentTaxpayer: null,
            showSuccessAlert: false,
            showAlert: false,
            alert: ''
        }
    },
    mounted () {
    },
    computed: {
        isOperator: function () {
            return this.$store.getters.getUserRole === this.$appConfig.role.operator
        },
        isInspector: function () {
            return this.$store.getters.getUserRole === this.$appConfig.role.inspector
        },
        isTaxpayer: function () {
            return this.$store.getters.getUserRole === this.$appConfig.role.dealer
        },
        isAdmin: function () {
            return this.$store.getters.getUserRole === this.$appConfig.role.admin
        },
        isCabinetRoot: function () {
            return /\/dealers\/\d+\/?$/gi.test(this.$route.path)
        },
        taxOrgs: function () {
            return this.$store.getters.getTaxOrgs
                ? this.$miscUtil.generateSelectList(this.$store.getters.getTaxOrgs, 'id', 'name')
                : []
        },
        isDealerRoute: function () {
            return /dealers\/\d+\/?/.test(this.$route.path)
        },
        isDisabled: function () {
            return this.$store.getters.isLoading
        }
    },
    methods: {
        getCurrentTaxpayer: function () {
            if (this.isTaxpayer) {
                this.currentTaxpayer = this.$store.getters.getCurrentTaxpayer
            } else if (this.$route.params.dealerId) {
                this.$request.sendRequest(this, this.$appConfig.apiUrls.dealer.getAll,
                    { id: this.$route.params.dealerId }, result => {
                        if (result.length !== 1) {
                            console.error('Get dealers by id from server must be return one item')
                            this.$router.push('/error/404')
                        }
                        this.currentTaxpayer = result[0]
                    }, this.displayAlert)
            }
        },
        hideAlert: function () {
            this.showAlert = false
            this.alert = ''
        },
        displayAlert: function (errorCode) {
            this.alert = this.$i18n.t(`errors.${errorCode}`)
            this.showAlert = true
        }
    }
}
